
export enum IdentificationActionEnum {
  DISPLAY_CALLS_DETAILS = 'DISPLAY_SHOW_CALLS_DETAILS',
  DISPLAY_ANNUAL_INVOICE_CONSOLIDATION = 'DISPLAY_ANNUAL_INVOICE_CONSOLIDATIONs',
  DISPLAY_TAX_INVOICE = 'DISPLAY_TAX_INVOICE',
  DISPLAY_ACCESSIBLE_INVOICE = 'DISPLAY_ACCESSIBLE_INVOICE',

}
